import { render, staticRenderFns } from "./warnTable.vue?vue&type=template&id=0cbb54a3&scoped=true&"
import script from "./warnTable.vue?vue&type=script&lang=js&"
export * from "./warnTable.vue?vue&type=script&lang=js&"
import style0 from "./warnTable.vue?vue&type=style&index=0&id=0cbb54a3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cbb54a3",
  null
  
)

export default component.exports